/*
  Farb-Swatches auf Produktkarten (gn-card-swatches)
  - Desktop: Swatches erscheinen beim Hover über die Karte (Event-Delegation – funktioniert
    auch für nachgeladene Inhalte wie "Könnte dir auch gefallen").
  - Mobil/Touch (kein Hover ODER Bildschirmbreite < 990px): Swatches sind immer sichtbar,
    auch nach AJAX-Nachladen (MutationObserver).
*/
(function () {
  function setVisible(el, on) {
    el.style.opacity = on ? '1' : '0';
  }

  function alwaysVisible() {
    if (!window.matchMedia) return false;
    return window.matchMedia('(hover: none)').matches || window.matchMedia('(max-width: 989px)').matches;
  }

  function showAll() {
    document.querySelectorAll('[data-card-swatches]').forEach(function (el) {
      setVisible(el, true);
    });
  }

  function init() {
    if (window.__cardSwatchesInit) return;
    window.__cardSwatchesInit = true;

    if (alwaysVisible()) {
      showAll();
      new MutationObserver(showAll).observe(document.documentElement, { childList: true, subtree: true });
    } else {
      document.addEventListener('mouseover', function (e) {
        if (!e.target || !e.target.closest) return;
        var card = e.target.closest('.card-wrapper');
        if (!card) return;
        var sw = card.querySelector('[data-card-swatches]');
        if (sw) setVisible(sw, true);
      });
      document.addEventListener('mouseout', function (e) {
        if (!e.target || !e.target.closest) return;
        var card = e.target.closest('.card-wrapper');
        if (!card) return;
        if (e.relatedTarget && card.contains(e.relatedTarget)) return;
        var sw = card.querySelector('[data-card-swatches]');
        if (sw) setVisible(sw, false);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
